module.exports = __webpack_public_path__ + "img/noImage-icon.b092ed69.svg";